<template>
    <div :style="{width, height, position: 'relative'}"
            :options="options"
    >
        <ECharts
                @zr:click="$emit('zr:click', $event)"
                @click="$emit('click', $event)"
                @touchmove="$emit('touchmove', $event)"
                @mousemove="mousemove"
                 ref="echarts"
                 :autoresize="true"
                 :style="{width, height}"
                 @legendselectchanged="legendselectchanged"
                 :options="options"></ECharts>
        <p v-if="noData" class="no-data chart-no-data" v-html="tips || '暂无数据'"></p>
    </div>
</template>
<script>

    // import Legend from "./legend/Legend";
    import {WaitReady} from "../../../assets/js/ready";


    const wait = WaitReady();

    export default {
        props: [
            'options',
            'width',
            'height',
            'loading',
            'noData',  // 是否显示暂无数据
            "tips",  // 提示文案
        ],
        components: {
            // Legend,
            ECharts: () => {
                return {
                    component: Promise.all([
                        import('echarts/lib/chart/line'),
                        import('echarts/lib/chart/scatter'),
                        import('echarts/lib/chart/bar'),
                        import('echarts/lib/component/legend'),
                        import('echarts/lib/chart/radar'),
                        import('echarts/lib/component/markPoint'),
                        import('echarts/lib/component/markLine'),
                        import('echarts/lib/chart/candlestick'),
                        import('echarts/lib/component/tooltip')
                    ]).then(() => {
                        return import('./VueEchart').then(res => {
                            setTimeout(function () {
                                wait.complete();
                            }, 50);
                            return res
                        })
                    }),
                    success: function(){

                    },
                    loading: require('../loading/LoadingComponent'),
                    delay: 200,
                }
            }
        },
        data() {
            return {
                interval: null
            }
        },
        watch: {
            loading: {
                immediate: true,
                handler(newVal) {
                    this.$nextTick(() => {
                        if (newVal === true) {
                            wait.ready(() => this.showLoading())
                        }
                        if(newVal === false){
                            wait.ready(() => this.hideLoading())
                        }
                    });

                }
            }
        },
        mounted(){
            wait.ready(() => {
                this.$emit('load')
            });
        },
        methods: {
            dispatchAction(){
                this.$refs.echarts.dispatchAction(...arguments)
            },
            clickEchart(e) {
                this.$emit('click', e)
            },
            mousemove(e) {
                this.$emit('mousemove', e)
            },
            legendselectchanged (e) {
                this.$emit('legendselectchanged', e)
            },
            showLoading(type) {

                this.$refs.echarts &&  this.$refs.echarts.showLoading(type, {
                    text: '',
                    lineWidth: 2,
                    color: 'rgba(153,153,153,0.51)',
                    maskColor: 'rgba(255,255,255, 0.8)'
                    // color: ''
                })

            },
            hideLoading() {
                this.$refs.echarts && this.$refs.echarts.hideLoading()
            }
        }
    }
</script>